module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Black.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Black.woff
// module id = 1886
// module chunks = 0